import React, { Component } from 'react'
import styled from 'styled-components'
import easing from 'ui/styles/easing'

const Wrapper = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  z-index: 4;

  &:hover {
    cursor: pointer;
  }
`

const Icon = styled.svg`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  transition: opacity 0.3s ${easing.easeOutCubic};
`

const Closed = styled(Icon)`
  opacity: ${props => props.active ? 0 : 1};
  `

const Open = styled(Icon)`
  opacity: ${props => props.active ? 1 : 0};
`

export default class SearchButton extends Component {
  render() {
    const { active } = this.props

    return(
      <Wrapper active={active}>
      
        <Closed
          active={active}
          width="23"
          height="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            transform="translate(1 1)"
            stroke="#FFF"
            strokeWidth="2"
            fill="none"
            fillRule="evenodd"
          >
            <circle
              cx="7"
              cy="7"
              r="7"
            />
            <path
              d="M13 11l7.6604444 6.4278761"
              strokeLinecap="round"
            />
          </g>
        </Closed>
        
        <Open
          active={active}
          width="21"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke="#FFF"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="square"
            d="M.01471906 1.30761228l20.50609666 20.50609666M20.52081572 2.01471906L.01471906 22.52081572"
          />
        </Open>
      
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/Navigation/SearchButton.js